var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"ui__button",class:_vm.type,attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" "+_vm._s(_vm.text)+" "),(_vm.icon)?_c('img',{staticClass:"ui__button-icon",attrs:{"src":_vm.icon}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }